import React, { useEffect } from "react"
import { magicAuth } from "actions/authentication"
import { useDispatch } from "react-redux"
import { getUser } from "actions/user"
import { openSnackBar } from "actions/snack-bar"
import { Box, CircularProgress } from "@material-ui/core"
import { logout } from "actions/authentication"

const Magic = ({ match, history }) => {
  const dispatch = useDispatch()
  const { magic, id } = match.params
  useEffect(() => {
    let token = null
    dispatch(magicAuth(id, magic))
      .then(res => {
        if (res.message === "auth success") {
          token = res.token
          return dispatch(getUser(id, res.token))
        } else {
          throw new Error("could not login with magic link")
        }
      })
      .then(res => {
        try {
          const host = window.location.host.split(".")
          const subdomain = res.user_orgs[0].subdomain
          const subMatches = res.user_orgs.filter(org => {
            return host[0] === org.subdomain
          })
          if (host.length === 3 && subMatches.length) {
            history.push(`/app/feed?token=${token}&user=${res.id}`)
          } else if (host.length === 3) {
            window.location = `http://${subdomain}.${host[1]}.${host[2]}/app/feed?token=${token}&user=${res.id}`
          } else {
            window.location = `http://${subdomain}.${host[0]}.${host[1]}/app/feed?token=${token}&user=${res.id}`
          }
        } catch (err) {
          console.log(err)
          dispatch(
            openSnackBar({
              message: "This account is not associated with any organizations"
            })
          )
          history.push("/noorganizationsage")
        }
      })
      .catch(err => {
        dispatch(logout())
      })
  }, [])

  return (
    <Box
      style={{ width: "100vw", height: "100vh" }}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress color="primary" />
    </Box>
  )
}

export default Magic



// WEBPACK FOOTER //
// ./src/pages/Magic/index.jsx